export default __webpack_public_path__ + "static/media/bedroom3.43269ae4.webp";